export enum Size {
  XS = 'xs',
  SM = 'sm',
  MD = 'md',
  LG = 'lg',
  XL = 'xl',
  FULL_WIDTH = 'fullWidth',
}

export enum ButtonType {
  ACTION = 'action',
  ACTION_INVERTED = 'actionInverted',
  CANCEL = 'cancel',
  CANCEL_INVERTED = 'cancelInverted',
  DANGER = 'danger',
  INLINE = 'inline',
  OPTION = 'option',
  SUCCESS = 'success',
}

export const enum FontStyle {
  BOLD = 'bold',
  ITALIC = 'italic',
  UNDERLINE = 'underline',
}

export const enum AlignText {
  LEFT = 'left',
  RIGHT = 'right',
  CENTER = 'center',
}

export const enum Position {
  LEFT = 'left',
  RIGHT = 'right',
  TOP = 'top',
  BOTTOM = 'bottom',
}
